import React from 'react';
import {
	ButtonGroup,
	PrimaryButton,
	TertiaryButton,
} from '@mlc/web-ui-toolkit';
import EpiTestIds from '../Account/Account.elements';
import { isCsr } from '../../../common/utils';
import { useAdviserDetails } from '../../../hooks/AppStateHook';

const ActionButtons = ({
	onCancelClick,
	onUpdateClick,
	isUpdating,
	ariaLiveId,
	forwardedRef,
}: {
	onCancelClick: () => void;
	onUpdateClick: () => void;
	isUpdating: boolean;
	ariaLiveId: string;
	forwardedRef: any;
}) => {
	const { roles } = useAdviserDetails();
	const UpdateButton = ({ updating }: { updating: boolean }) => (
		<PrimaryButton
			isLoading={updating}
			data-id={EpiTestIds.updateButton}
			aria-controls={ariaLiveId}
			onClick={onUpdateClick}
			ref={forwardedRef}
			disabled={isCsr(roles)}
		>
			{updating ? 'Updating...' : 'Update'}
		</PrimaryButton>
	);

	return (
		<ButtonGroup align="left">
			<UpdateButton updating={isUpdating} />
			<TertiaryButton
				data-id={EpiTestIds.cancelButton}
				type="button"
				onClick={onCancelClick}
			>
				Cancel
			</TertiaryButton>
		</ButtonGroup>
	);
};

export default ActionButtons;
